<template>
  <div class="experiment-module">
    <div
      v-if="!loadItem"
      class="container px-md-4"
    >
      <b-row class="d-flex justify-content-between">
        <b-col
          lg="6"
          md="6"
          class="content-section"
        >
          <div
            v-if="experimentDetails"
            class="content-wrapper pl-1"
          >
            <h5 class="experiment-subtitle text-light">
              {{ experimentDetails.category_name }}
            </h5>
            <h1
              class="experiment-title font-weight-bold mb-1 text-light"
            >{{ experimentDetails.name }}</h1>
            <p class="experiment-description mb-2 text-light">
              {{ experimentDetails.description }}
            </p>
            <div class="progress-section mb-2">
              <label class="mb-50 font-weight-normal text-light">PROGRESS</label>
              <div class="progress-wrapper">
                <b-progress
                  :value="experiment.progress"
                  :max="100"
                  height="14px"
                  class="custom-progress"
                />

                <div
                  class="progress-indicator"
                  :style="{ left: `calc(${experiment.progress}% - 10px)` }"
                />
              </div>
            </div>

            <b-button
              v-b-tooltip.hover.top="'Run only via VR'"
              variant="disabled"
              size="lg"
              class="run-button disabled"
              :disabled="true"
              @click.stop="openExperiment(experimentDetails.targetPackage)"
            >
              <b-img
                src="@/assets/images/skeleton/play1.png"
                alt="Run"
                class="mr-2"
              />Run
            </b-button>
          </div>
        </b-col>

        <b-col
          lg="6"
          md="6"
        >
          <div class="w-100 image-section">
            <div class="image-gallery px-md-3">
              <div class="main-image-container mb-2">
                <video
                  v-if="currentMainMediaType.startsWith('video')"
                  controls
                  class="main-image rounded mr-1"
                  style="width:100%; max-height:400px; object-fit:cover;"
                >
                  <source
                    :src="currentMainMedia"
                    :type="currentMainMediaType"
                  >
                  Your browser does not support video playback.
                </video>
                <b-img
                  v-else
                  :src="currentMainMedia"
                  fluid
                  alt="Main experiment media"
                  class="main-image rounded mr-1"
                />
              </div>
              <div class="thumbnail-column d-flex flex-column justify-content-center">
                <div
                  v-for="(thumb, index) in thumbnails"
                  :key="index"
                  class="thumbnail-container mb-2"
                  @click="switchMainMedia(index)"
                >
                  <video
                    v-if="thumb.type && thumb.type.startsWith('video')"
                    muted
                    loop
                    playsinline
                    preload="metadata"
                    class="thumbnail-image rounded"
                    style="width:70px; height:75px; object-fit:cover;"
                  >
                    <source
                      :src="thumb.url"
                      :type="thumb.type"
                    >
                  </video>

                  <b-img
                    v-else
                    :src="thumb.url"
                    fluid
                    alt="Thumbnail"
                    class="thumbnail-image rounded"
                    :class="{ active: currentMainMedia === thumb.url }"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="px-2">
        <div
          v-if="!randLoad"
          class="recommendation-section mt-2 w-100"
        >
          <h4 class="mb-2 font-weight-bold text-white">
            YOU MIGHT ALSO LIKE
          </h4>
          <b-row class="w-100">
            <b-col
              v-for="(item, index) in rands.data"
              :key="index"
              cols="12"
              md="4"
            >
              <b-card
                class="rec-card"
                @click="navigateEXP(item.id)"
              >
                <b-row
                  no-gutters
                  align-h="between"
                  align-v="center"
                >
                  <b-col
                    cols="8"
                    class="text-section px-1"
                  >
                    <h5 class="rec-title font-weight-bold text-white mb-1">
                      {{ item.name }}
                    </h5>
                    <p class="rec-subtitle text-white-50 mb-0">
                      {{ item.category_name }}
                    </p>
                  </b-col>

                  <b-col cols="4">
                    <b-img
                      :src="item.image"
                      alt="Recommendation Image"
                      class="rec-image rounded"
                      fluid
                    />
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <div
            v-if="hasRole('Admin')"
            class="w-100"
          >
            <!-- <h4 class="mb-2 font-weight-bold text-white">prompt</h4>
            <p class="experiment-description mb-2 text-light">{{ experimentDetails.prompt }}</p> -->
            <!-- <h4 class="mb-2 font-weight-bold text-white">Publish URL</h4>
            <p class="experiment-description mb-2 text-light">{{ experimentDetails.publish_URL }}</p> -->
          </div>
        </div>
        <center
          v-else
          class="mt-5"
        >
          <b-spinner
            variant="primary"
            label="Spinning"
          />
        </center>
      </b-row>
    </div>
    <center v-else>
      <b-spinner
        variant="primary"
        label="Spinning"
      />
    </center>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BRow,
  BCol,
  BProgress,
  BCard,
  BButton,
  BIcon,
  BImg,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'ConcreteExperimentPage',
  components: {
    BRow,
    BCol,
    BProgress,
    BButton,
    BIcon,
    BImg,
    BCard,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      experimentDetails: 'experiments/item',
      loadItem: 'experiments/loadItem',
      rands: 'experiments/rands',
      randLoad: 'experiments/randLoad',
    }),
    id() {
      return this.$route.params.id ? this.$route.params.id : null
    },
  },
  data() {
    return {
      currentMainMedia: null,
      currentMainMediaType: 'image',
      thumbnails: [],
      experiment: {
        progress: 0,
      },
    }
  },
  watch: {
    experimentDetails: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // main image always shown first
          this.currentMainMedia = newVal.image
          this.currentMainMediaType = 'image'

          // take first 3 media items for thumbnails
          this.thumbnails = (newVal.images || []).slice(0, 3).map(m => ({
            url: m.url,
            type: m.type || 'image/png',
          }))
        }
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    switchMainMedia(index) {
      const clicked = this.thumbnails[index]
      const oldMain = {
        url: this.currentMainMedia,
        type: this.currentMainMediaType,
      }

      // swap
      this.currentMainMedia = clicked.url
      this.currentMainMediaType = clicked.type

      this.$set(this.thumbnails, index, oldMain)
    },
    navigateEXP(exp_id) {
      this.$store.dispatch('experiments/get', exp_id)
      this.$store.dispatch('experiments/RandExperiments')
    },
    init() {
      this.$store.dispatch('experiments/get', this.id).then(res => {
        this.experiment.progress = res.data.progress || 0
      })
      this.$store.dispatch('experiments/RandExperiments')
    },
    openExperiment(id) {
      if (id) setTimeout(() => window.vuplex.postMessage(id), 3)
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  background: linear-gradient(144deg, #1d133f 19%, #0e152b 41%, #12232f 87%);
  color: white;
}
.btn {
  cursor: not-allowed !important;
}
.experiment-module {
  padding: 0rem 1.5rem;
  padding-top: 1rem;
  animation: fadeIn 1s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content-wrapper {
    max-width: 100%;
    animation: slideInLeft 1s ease forwards;
    color: #e9ecef;
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }
  .progress-section {
    .progress-wrapper {
      position: relative;
      width: 80%;
    }

    .custom-progress {
      border-radius: 8px;
      box-shadow: inset 0 2px 20px rgba(0, 0, 0, 0.4);
      transition: width 0.5s ease;

      ::v-deep .progress-bar {
        border-radius: 8px;
        background-color: #ffffffba !important;
      }
    }

  }

  .run-button {
    // background: linear-gradient(144deg, #1d133f 19%, #0e152b 41%, #12232f 87%);
    // background: linear-gradient(
    //   90deg,
    //   rgba(133, 13, 204, 1) 0%,
    //   rgba(15, 217, 222, 1) 100%
    // );
    // background: linear-gradient(90deg, #6c3adf 0%, #23c7ec 100%) !important;
    // color: white !important;
    padding: 3px 17px 3px 6px;
    font-weight: 600;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease, box-shadow 0.3s ease;
    animation: slideInUp 1s ease forwards;
    border: 2px solid #ffffff2e !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 50px;

    @keyframes slideInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    &:hover {
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 6px 20px rgba(166, 167, 170, 0.4);
    }
  }

  .run-button:hover {
    background-color: rgba(233, 236, 239, 0.693) !important;
  }

  .image-gallery {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    animation: fadeIn 1.2s ease-in-out;
    .main-image-container {
      max-width: 360px;
      max-height: 360px;

      .main-image {
        width: 360px;
        height: 360px;
        object-fit: cover;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transition: transform 0.4s ease;

        &:hover {
          transform: scale(1.03);
        }
      }
    }

    .thumbnail-column {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .thumbnail-container {
        overflow: hidden;
        width: 80px !important;
        height: 80px !important;

        .thumbnail-image {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          &:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }

  .recommendation-section {
    width: 90%;
    margin-top: 3rem;
    h4{
      text-transform: uppercase;
    }
    .rec-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 12px;
      border: none;
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      animation: fadeIn 1.5s ease-in-out;
      .card-body{
        padding: 10px;
      }
      &:hover {
        transform: translateY(-5px) scale(1.03);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .image-section{
    display: flex;
    justify-content: end;
  }
  @media (max-width: 1514px){
    .image-gallery {
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .thumbnail-column {
        flex-direction: row !important;
        justify-content: center;
        flex-wrap: wrap;
        width: 100% !important;
        .thumbnail-container {
          width: 60px;
          display: inline;
          height: 60px;
        }
      }
    }
  }
  @media (max-width: 991px) {

    .image-gallery {
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .thumbnail-column {
        flex-direction: row !important;
        justify-content: center;
        flex-wrap: wrap;
        width: 100% !important;
        .thumbnail-container {
          width: 60px;
          display: inline;
          height: 60px;
        }
      }
    }

    .custom-progress {
      width: 100%;
    }

    .run-button {
      margin-bottom: 3rem;
      cursor: not-allowed !important;
    }
  }

  @media (max-width: 768px){
    .image-section{
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 576px) {
    .experiment-title {
      font-size: 36px;
    }

    .experiment-subtitle {
      font-size: 1rem;
    }

    .experiment-description {
      font-size: 0.9rem;
    }

    .thumbnail-column {
      .thumbnail-container {
        width: 50px;
        height: 50px;
      }
    }

    .rec-card {
      .rec-title {
        font-size: 1rem;
      }

      .rec-subtitle {
        font-size: 0.85rem;
      }
    }
  }
}
.rec-image {
  // max-width: 100px;
  width: 100px;
  height: 100px;
  float: right;
}
.custom-progress ::v-deep .progress-bar {
  background: linear-gradient(144deg, #1d133f 19%, #0e152b 41%, #12232f 87%);
}

.experiment-title {
  font-family: "Montserrat", sans-serif;
  text-transform: uppercase;
  font-weight: lighter !important;
}
.experiment-subtitle {
  font-family: "Montserrat", sans-serif;
  color: #ebebeb7b !important;
  font-size: 14px !important;
  font-style: italic;
}
.experiment-description {
  font-family: "Montserrat", sans-serif;
  color: #ebebebcc !important;
  font-size: 16px !important;
}

.progress-section {
  .progress-wrapper {
    position: relative;
    width: 80%;
    margin-top: 10px;
  }

  label {
    font-size: 0.9rem;
    letter-spacing: 1px;
    font-weight: 500;
    color: #d8d8d8;
  }

  .custom-progress {
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.06);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    overflow: hidden;

    // inner progress bar
    ::v-deep .progress-bar {
      border-radius: 50px;
      background: linear-gradient(90deg, #3c2c8f 0%, #2a2f5f 60%, #1f2348 100%);
      transition: width 0.4s ease;
      box-shadow: 0 0 15px rgba(50, 80, 255, 0.3);
    }
  }

  .progress-indicator {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 13px;
    background: #00e5ff;
    border-radius: 50%;
    box-shadow: 0 0 10px #00e5ff, 0 0 25px rgba(0, 229, 255, 0.4);
    pointer-events: none;
    transition: left 0.4s ease;
  }
}
</style>
